import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface CancelData {
    cancel_reason_idx: number;
    cancel_reason: string;
    admin_option: boolean;
}

interface GetCancelResponse {
    data: CancelData[];
}

export const useGetCommonCancel = (admin_option?: boolean, enabled?: any): UseQueryResult<GetCancelResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCancelResponse, Error>({
        queryKey: ["getCommonCancel", admin_option],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.common_get_cancel}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: admin_option ? { admin_option } : {},
            });
            return response.data;
        },
        enabled: enabled,
    });
};
